 <template>
 <div style="background-color:whitesmoke;width:100%;height:100%">
  <div class="content-table">
    <el-dialog :visible.sync="tellShow" title="更换手机号" width="40%">
      <div style="display: inline-block;padding-right: 10%;">
        <div class="col-12 col-6-dialog">
          <div class="col-3">
            <span>
              <span class="redstar">*</span>联系人
            </span>
          </div>
          <div class="col-9">
            <el-input v-model="telname" size="medium" placeholder="不能为昵称,X先生,X小姐等" clearable>
              <i
                slot="suffix"
                class="el-input__icon el-icon-chat-dot-round"
                title="电话确认收货人不在现场指定人员代收货"
              ></i>
            </el-input>
          </div>
        </div>
        <div class="col-12 col-6-dialog">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 手机号码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="text"
              v-model="telphone"
              size="medium"
              placeholder="请填写手机号码"
              validate-event
              onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
              show-word-limit
              clearable
            ></el-input>
          </div>
        </div>
        <div class="content-row">
          <div class="col-12 col-6-dialog">
            <div class="col-3">
              <span>
                <span class="redstar">*</span>申诉原因
              </span>
            </div>
            <div class="col-9">
              <el-input type="textarea" autosize placeholder="请输入内容" v-model="tel_detail_address"></el-input>
            </div>
          </div>
        </div>
        <div class="content-center-row" style="font-size:14px;margin: 20px 0px;">
          <span>申诉成功需重新验证登陆，结果将以电话形式告知，请注意查收。</span>
        </div>
        <div class="content-center-row">
          <el-button @click="btnTelSubmit()" type="primary" class="btn_class" plain size="small">确 认</el-button>
          <el-button @click="btnReturn()" type="info" plain class="btn_class" size="small">返 回</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="passwordShow" title="修改账号密码" width="40%">
      <div style="display: inline-block;padding-right: 10%;">
        <div class="col-12 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 手机号码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="text"
              v-model="passwordphone"
              size="medium"
              placeholder="请填写手机号码"
              validate-event
              onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
              show-word-limit
              clearable
            ></el-input>
          </div>
        </div>
        <div class="col-12 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 验证码
            </span>
          </div>
          <div class="col-6">
            <el-input type="text" v-model="sms" size="medium" placeholder="请填写验证码" clearable></el-input>
          </div>
          <div class="col-3">
            <input
              v-show="sendAuthCode"
              class="el-input__inner"
              style="height: 35px; line-height: 35px;"
              type="button"
              value="获取验证码"
              @click="go_yz"
            />
            <input
              v-show="!sendAuthCode"
              class="el-input__inner"
              style="height: 35px; line-height: 35px;color:red;border:1px solid red;"
              type="button"
              :value="auth_timetimer"
              @click="go_yz"
            />
          </div>
        </div>
        <div class="col-12 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 新密码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="password"
              v-model="passwordfp1"
              size="medium"
              placeholder="请输入密码"
              show-word-limit
              showPassword
            ></el-input>
          </div>
        </div>
        <div class="col-12 col-6-dialog" style="margin-top:15px;">
          <div class="col-3">
            <span>
              <span class="redstar">*</span> 确认密码
            </span>
          </div>
          <div class="col-9">
            <el-input
              type="password"
              v-model="passwordfp2"
              size="medium"
              placeholder="请再次确认您的密码"
              show-word-limit
              showPassword
              clearable
            ></el-input>
          </div>
        </div>
        <div class="content-center-row" style="font-size:14px;margin: 20px 0px;">
          <span>申诉成功需重新验证登陆，结果将以电话形式告知，请注意查收。</span>
        </div>
        <div class="content-center-row">
          <el-button @click="btnPasswordSubmit()" type="primary" class="btn_class" plain size="small">确 认</el-button>
          <el-button @click="btnReturn()" type="info" class="btn_class" plain size="small">返 回</el-button>
        </div>
      </div>
    </el-dialog>
    <div class="item-content"></div>
    <div class="main">
      <!-- <img src="static/image/xoa.png" alt @click="uesrCenter()" /> -->
      <!-- <el-image class="y-img-ring" :src="'api'+imageUrl"></el-image> -->
      <div class="main-left" v-show="show_left">
<!--        <div class="left-img" @click="closeMenu()">-->
<!--          -->
<!--          <el-image class="y-img-ring" :src="imageUrl"></el-image>-->
<!--        </div>-->
<!--        <div>-->
<!--          <p class="left-name">-->
<!--            <span v-if="invoicebill !=null">{{invoicebill.title}}</span>-->
<!--          </p>-->
<!--        </div>-->
        <div>
          <el-menu
            class="el-menu-vertical-demo"
            ref="menu"
            @close="handleClose"
            :default-openeds="['1','2']"
          >
            <el-submenu index="1">
              <template slot="title">
                <div>
                  <i class="el-icon-bell"></i>
                  <span style="font-size:14px;font-weight: bold;text-align: left;">个人中心</span>
                </div>
              </template>
              <el-menu-item-group>
                <el-menu-item index="1-1">
                  <div @click="my_collect()">
                    <span>我的收藏</span>
                  </div>
                </el-menu-item>
                <el-menu-item index="1-2">
                  <div @click="deliveryAddress()">
                    <span>地址管理</span>
                  </div>
                </el-menu-item>
                <el-menu-item index="1-3">
                  <div @click="my_register()">
                    <span>注册信息</span>
                  </div>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>
            <el-submenu index="2">
              <template slot="title">
                <i class="el-icon-tickets"></i>
                <span style="font-size:14px;font-weight: bold;text-align: left;">订单中心</span>
              </template>
              <el-menu-item-group>
                <el-menu-item
                  v-for="(item,index) in my_order_list"
                  :index="'2-'+(index + 1)"
                  :key="index"
                  @click="lookOrderbyStatus(item.status,index)"
                >
                  <span>{{item.name}}</span>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>

            <!-- <el-submenu index="3">
              <template slot="title">
                <i class="el-icon-document"></i>
                <span style="font-size:14px;font-weight: bold;">资金账户</span>
              </template>
              <el-menu-item-group>
                <el-menu-item index="3-1">
                  <div @click="pipeline_record()">
                    <span style="padding-left:35px;">流水记录</span>
                  </div>
                </el-menu-item>
              </el-menu-item-group>
            </el-submenu>-->
          </el-menu>
        </div>
      </div>

      <div v-show="show == 1" class="main-right">
        <div class="content-left-row personal-header">
          <div v-if=" customRegister != null " class="personal-header-left">
            <div class="y-header-item-z">
              <el-upload
                class="avatar-uploader"
                action="/xuou/public/index.php/index/common/return_img_url"
                accept="image/jpeg, image/jpg, image/png"
                :file-list="fileList"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
              >
                <img v-if="imageUrl" :src="imageUrl" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </div>
            <div class="y-header-item-z1">
              <p>欢迎登陆</p>
              <!-- <p>账 号： {{customRegister.account}}</p> -->
              <p>
                <!-- 密 码：
                <input
                  class="d-input-password"
                  style="width:90px;"
                  disabled
                  type="password"
                  name="password"
                  id
                  :value="customRegister.tel"
                />-->
                登陆账号:{{customRegister.account}}
                <!-- <span
                  class="y-header-item-z1-xiu"
                  style="cursor: pointer;"
                  @click="changPassword"
                >修改密码</span>-->
                <el-button @click="changPassword" type="warning" plain round size="mini">修改密码</el-button>
              </p>
            </div>
          </div>
          <div class="y-right-header-item" v-if=" customRegister != null ">
            <!-- <div class="y-header-item-z2" style="display:flex;width:100%;">
              <div
                style="width:20%; background: url('/static/image/xo-yu.png') no-repeat;background-position: 0px 24px;background-size: contain;"
              ></div>
              <div style="width:70%;margin-left:10%;">
                <p>账户余额</p>
                <p class="y-header-item-z2-p">￥{{customInfo}}</p>
              </div>
            </div>-->
            <div class="y-header-item-z1">
              <p>联系人：{{customRegister.contacts}}</p>
              <p>
                手机号码:{{customRegister.tel}}
                <el-button @click="tellShow = true" type="warning" plain round size="mini">修改手机号</el-button>
              </p>
            </div>
          </div>
        </div>
        <div class="content-left-row personal-order">
          <div class>
            <h4 style="margin: 14px 0;">我的订单</h4>
          </div>
          <hr class="personal-hr" />
          <div class="red-solid"></div>
          <div class="y-right-main-center">
            <div
              class="my-order-div"
              v-for="(item,index) in my_order_data"
              :key="index"
            >
              <div class="content-row order-div-row-1 f-15" style="margin-bottom:0;">
                <div class="a-my-order">
                  <div class="a-my-order-list a-my-order-list1">
                    <span class="b-my-order">{{item.created_at}}</span>
                    <span>订单号: {{item.order_sn}}</span>
                  </div>
                  <div class="a-my-order-list a-my-order-list2">
                    订单总额
                    <span style="color:red;font-size: 15px;">￥{{item.pay_amount}}</span>
                  </div>
                </div>
                <div style="width:100%">
                  <el-table
                    :data="item.order_good"
                    :show-header="false"
                    border
                    :span-method="prop=>returnRequestSpanMethod3(prop,item.order_good.length)"
                    class="order-goods"
                  >
<!--                    width="1015"-->
                    <el-table-column prop="spu_name" align="center" min-width="300px" border>
                      <template slot-scope="scope">
                        <div style="display:flex">
<!--                          <div>-->
<!--                            <el-image-->
<!--                              v-if="scope.row.pic!=''&&scope.row.pic!=null"-->
<!--                              :src="scope.row.pic"-->
<!--                              style="width:50px"-->
<!--                            ></el-image>-->
<!--                            <el-image v-else src="static/image/error.png" style="width:50px"></el-image>-->
<!--                          </div>-->
                          <div >
                            <div style="display: flex;flex-direction: column;text-align: left;">
                              <div style="display:flex;font-size:12px;">
                                <div
                                  style="margin-right:5px"
                                >{{scope.row.order_good_name}}</div>
                                <div style="font-size: 20px;">|</div>
                                <div style="margin-left:5px">{{scope.row.good_banane}}</div>
                              </div>
                              <div
                                style="text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;white-space:pre;  "
                              >{{scope.row.order_good_spec}}</div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </el-table-column>
<!--                    <el-table-column align="center"  >-->
<!--                      <template slot-scope="scope">-->
<!--                        <div>{{scope.row.order_good_spec}}</div>-->
<!--                      </template>-->
<!--                    </el-table-column>-->
<!--                    width="80px"-->
                    <el-table-column align="center"  >
                      <template slot-scope="scope">
                        <div>{{scope.row.order_good_qty}}</div>
                      </template>
                    </el-table-column>
<!--                    width="128px"-->
                    <el-table-column align="center" >
                      <template slot-scope="scope">
                        <div style="float: right;">{{scope.row.tax_price}}</div>
                      </template>
                    </el-table-column>
<!--                    width="120px"-->
                    <el-table-column  show-overflow-tooltip align="center" width="120px">
                      <template slot-scope="scope">
                        <span>{{scope.row.ware_name}}</span>
                      </template>
                    </el-table-column>
<!--                    width="130px"-->
                    <el-table-column align="center" >
                      <template >
                        <div v-if="item.order_status.id == '1'">
                          <small>待审核</small>
                        </div>
                        <div v-if="item.order_status.id == '2'">
                          <small>待出库</small>
                        </div>
                        <div v-if="item.order_status.id == '3'">
                          <small>已出库</small>
                        </div>
                        <div v-if="item.order_status.id == '4'">
                          <small>已完成</small>
                        </div>
                        <div>
                          <div
                            style="color:#C39A58;cursor: pointer;"
                            @click="orderDetail(item)"
                          >订单详情</div>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center"  width="130px">
                      <template>
                        <el-button
                          type="warning"
                          plain
                          round
                          size="mini"
                          @click="option_order(item)"
                        >再来一单</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>
            </div>
          </div>
          <div class="personal-oder-page">
            <el-pagination
              @size-change="handleSizeChange_my_order"
              @current-change="handleCurrentChange_my_order"
              :current-page.sync="currentPage_my_order"
              :page-size="pageSize_my_order"
              layout="total,prev, pager, next, jumper"
              :total="total_my_order"
            ></el-pagination>
          </div>
        </div>
        <div class="content-left-row personal-order" style="padding-bottom:2%">
          <div class>
            <h4 class="personal-h4">我的收藏</h4>
          </div>
          <hr class="personal-hr" />
          <div class="red-solid"></div>
          <div class="y-right-main-center">
            <div class="y-right-main-center-list">
              <div
                class="personal-goods"
                v-for="(item,index) in my_collection"
                :key="index"
                style="margin:0 1%; margin-top:1%;position: relative;"
              >

                <div class="u-list">
                  <div class="u-list-img">
                    <img
                      :src="item.pic"
                      class="u-list-img-img"
                      v-if="item.pic!='' && item.pic!= null"
                    />
                    <el-image v-else src="static/image/error.png" style="width: 85%;"></el-image>
                  </div>
                  <div class="price-div z-color">￥ {{item.good_price}}</div>
                  <div class="goodName-div">{{item.good_name}}</div>
                  <div class="spec-div" style="white-space: pre;">{{item.good_spec}}</div>
                  <div class="goods-btn">
                    <el-button
                      @click="good_cart(item)"
                      type="danger"
                      plain
                      round
                      size="small"
                      class="join-cart"

                    >加入购物车</el-button>
<!--                  style="padding: 3% 5%;min-width: 100px;"  -->
                    <el-button
                      type="warning"
                      size="small"
                      plain
                      round
                      class="join-cart-sc"
                      @click="collectionGood(item.good_erpid,index)"
                    >
<!--                     style="padding: 3% 5%;min-width: 60px;" -->
                      <i class="fa fa-heart button-icon" plain aria-hidden="true"></i>
                      取消收藏
                    </el-button>
                  </div>

                  <!-- <el-button round @click="good_cart(item)">加入购物车</el-button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 订单详情 -->
      <div
        class="main-right"
        v-show="currentStatus == -1 && show != 1 && detail_order == 1 && collect_list != 1 && my_deliveryAddress != 1  && register != 1 && my_pipeline !=1 "
      >
        <p style="color:#c39a58"></p>
        <div class="right-page order_detail">
          <!-- 收货地址：{{Receiver}}(收) {{Address}}{{Phone}} -->
          <!-- <div class="content-left-row">
            <div class="detail-div f-15">
              <div class="content-left-row">{{Receiver}}(收)</div>
              <div class="content-row">
                <el-divider></el-divider>
              </div>
              <div class="content-left-row">{{Address}}{{Phone}}</div>
            </div>
          </div>-->
          <!-- <div class="content-row b-invoice" v-if="order_detail_data.is_invoice !=2 ">
            <p style="color:#c39a58">开票信息</p>
            <div class="credit1">
              <p class="b-font-fp">
                <span v-if="invoicesite_info !=null ">发票信息： {{invoicesite_info.title}}</span>
                <span v-if="invoicesite_info.finvoice !=null ">{{invoicesite_info.finvoice.value}}</span>
              </p>
              <p class="b-font-fp">
                <span
                  v-if="invoice_info !=null "
                >收票信息：{{invoice_info.receiver}} {{invoice_info.province_name}} {{invoice_info.city_name}} {{invoice_info.area_name}} {{invoice_info.addr}}</span>
              </p>
            </div>
          </div>-->
          <!-- <div>物流单号：154545454545 支付方式：线下支付</div> -->
          <div class="content-row">
            <div class="content_row">
              <p style="text-align:left; color:#c39a58">支付方式</p>
            </div>
            <div class="content_row credit1">
              <div>
                <div class="row_sty credit_back" style="border:1px solid #efefef;">
                  <img src="static/image/qianpay.png" align="absmiddle" />
                  <span v-if="order_detail_data.pay_type != null">
                    <span>{{order_detail_data.pay_type.name}}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="content-row" style="text-align:left" id="logistics_dtaile">
            <div class="content_row">
              <p style="text-align:left; color:#c39a58">物流信息</p>
            </div>
            <el-row>
              <el-col :span="16">
                <div class="grid-content bg-purple b-font-fp">
                  <span>物流单号：</span>
                  <span v-if="order_detail_data.logistics == null">暂无物流单号</span>
                  <span v-else>{{logistics_code}}</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div class="grid-content bg-purple-light b-font-fp">
                  <span>物流方式：</span>
                  <span v-if="order_detail_data.logistics == null">暂无物流方式</span>
                  <span
                    style="color:#555;"
                    v-if="order_detail_data.delivery != null"
                  >{{order_detail_data.delivery.name}}</span>
                </div>
              </el-col>
            </el-row>
          </div>
          <div class="content-row" style="margin-bottom:3%;width:98%;margin-left:1%;">
            <div class="col-12">
              <el-table :data="order_detail_data.order_good" border class="table-attr">
                <!-- returnRequestSpanMethod1 -->
                <el-table-column prop="spu_name" align="center" border label="产品信息" width="340px">
                  <!-- <template slot-scope="scope">
                    <div style="display: flex;flex-direction: column;text-align: left;">
                      <div style="display:flex;font-size:12px;">
                        <div
                          style="width:50%;text-align:right;margin-right:5px"
                        >{{scope.row.order_good_name}}</div>
                        <div style="font-size: 20px;">|</div>
                        <div style="width:48%;margin-left:5px">{{scope.row.good_banane}}</div>
                      </div>
                    </div>
                  </template>-->
                  <template slot-scope="scope">
                    <div style="display:flex">
                      <div>
                        <el-image
                          v-if="scope.row.pic!=''&&scope.row.pic!=null"
                          :src="scope.row.pic"
                          style="width:50px"
                        ></el-image>
                        <el-image v-else src="static/image/error.png" style="width:50px"></el-image>
                      </div>
                      <div style="width: 68%;margin-left:5%">
                        <div style="display: flex;flex-direction: column;text-align: left;">
                          <div style="display:flex;font-size:12px;">
                            <div
                              style="margin-right:5px"
                            >{{scope.row.order_good_name}}</div>
                            <div style="font-size: 20px;">|</div>
                            <div style="margin-left:5px">{{scope.row.good_banane}}</div>
                          </div>
                          <div
                            style="white-space: pre;text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;    margin-left: 20px;"
                          >{{scope.row.order_good_spec}}</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="good_spec" border align="center" label="规格" width="210px">
                  <template slot-scope="scope">
                    <div
                      style="white-space: pre;text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;"
                    >{{scope.row.order_good_spec}}</div>
                  </template>
                </el-table-column>-->
                <el-table-column class="center-td" align="center" label="数量" prop="order_good_qty"></el-table-column>
                <el-table-column class="center-td" align="right" label="优惠金额" prop="prefer_amount"></el-table-column>
                <el-table-column class="center-td" align="right" label="含税单价" prop="tax_price"></el-table-column>
                <el-table-column class="center-td" align="center" label="重量/Kg" prop="weight"></el-table-column>
                <el-table-column class="center-td" align="right" label="合计">
                  <template
                    slot-scope="scope"
                  >{{(scope.row.order_good_qty * scope.row.tax_price).toFixed(2)}}</template>
                </el-table-column>
                <!-- <el-table-column class="center-td" align="right" label="总金额">
                  <template slot-scope="scope">
                    <span>{{order_detail_data.pay_amount}}</span>
                  </template>
                </el-table-column>-->
                <el-table-column class="center-td" align="center" label="仓库" width="120">
                  <template slot-scope="scope">
                    <span>{{scope.row.ware_name}}</span>
                  </template>
                </el-table-column>
                <!-- <el-table-column class="center-td" align="center" label="状态">
                  <template slot-scope="scope">
                    <div v-if="order_detail_data.order_status.id == '1'">
                      <small style="color:red;">待审核</small>
                    </div>
                    <div v-if="order_detail_data.order_status.id == '2'">
                      <small style="color:red;">待出库</small>
                    </div>
                    <div v-if="order_detail_data.order_status.id == '3'">
                      <small style="color:red;">已出库</small>
                    </div>
                    <div v-if="order_detail_data.order_status.id == '4'">
                      <small style="color:red;">已完成</small>
                    </div>
                    <div>
                      <strong style="cursor: pointer;" @click="click_logistics">查看物流</strong>
                    </div>
                  </template>
                </el-table-column>-->
              </el-table>
            </div>
          </div>
          <div style="width: 98%;display: flex;background-color:#f5f5f5;padding-bottom: 2%;margin-left:1%;">
            <div style="padding: 0% 2%;width: 31%;">
              <h5>收货人信息</h5>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">收货人：</div>
                <div>{{Receiver}}(收)</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">手机号：</div>
                <div style="width:70%">{{Phone}}</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">收货地：</div>
                <div style="width:70%;">{{Address}}</div>
              </div>
            </div>
            <div style="padding: 0% 2%;    width: 31%;">
              <h5>配送方式</h5>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">物流单号：</div>
                <div>{{logistics_code}}</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">配送方式：</div>
                <div style="width:70%">{{deliveryMode}}</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">发票信息：</div>
                <div style="width:70%;">{{invoicesite_info.title}}</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:25%">收票信息：</div>
                <div
                  style="width:70%;"
                >{{invoice_info.receiver}} {{invoice_info.province_name}} {{invoice_info.city_name}} {{invoice_info.area_name}} {{invoice_info.addr}}</div>
              </div>
            </div>
            <div style="padding: 0% 2%;    width: 32%;">
              <h5>付款信息</h5>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:30%">商品总金额：</div>
                <div style="width:70%">￥{{Allamount}}</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:30%">优惠金额：</div>
                <div style="width:70%;">￥{{PreferAmount}}</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:30%">货物净重：</div>
                <div style="width:70%;color:red">{{all_weight}} Kg</div>
              </div>
              <div style="display: flex;padding-bottom: 7px;font-size: 13px;">
                <div style="width:30%">应付金额：</div>
                <div style="width:70%;color:red">￥{{AllAmount}}</div>
              </div>
            </div>
          </div>
          <div class="content-row f-15">
            <el-button
              @click="view_co"
              size="medium"
              plain
              style="margin: 2% 0px;padding: 10px 45px;"
            >返回</el-button>
          </div>
        </div>
      </div>
      <!-- 我的订单 -->
      <div class="main-right" 　 v-show="currentStatus != -1 && show != 1">
        <div class>
          <div>
            <div style="display:flex;    justify-content: space-between;">
              <div>
                <h4 class="personal-h4" v-if="currentStatus == ''">全部订单</h4>
                <h4 class="personal-h4" v-if="currentStatus == '1'">待审核</h4>
                <h4 class="personal-h4" v-if="currentStatus == '2'">待出库</h4>
                <h4 class="personal-h4" v-if="currentStatus == '3'">已出库</h4>
                <h4 class="personal-h4" v-if="currentStatus == '4'">已完成</h4>
              </div>
              <div class="a-order-right">
                <el-input
                  class="search"
                  placeholder="订单编号 / 规格 / 商品名称"
                  v-model="keyword"
                  @keyup.enter="getGoodInfo()"
                >
                  <i
                    slot="suffix"
                    class="el-input__icon el-icon-search"
                    @click="getGoodInfo()"
                    style="line-height: 35px;"
                  ></i>
                </el-input>
              </div>
            </div>
            <hr class="personal-hr" />
            <div class="red-solid"></div>
          </div>
          <div
            class="my-order-div"
            v-for="(item,index) in my_order_data"
            :key="index"
          >
            <div class="content-row order-div-row-1 f-15" style="margin-bottom:0;">
              <div class="a-my-order">
                <div class="a-my-order-list a-my-order-list1">
                  <span class="b-my-order">{{item.created_at}}</span>
                  <span>订单号: {{item.order_sn}}</span>
                </div>
                <div class="a-my-order-list a-my-order-list2">
                  订单总额
                  <span style="color:red;font-size: 15px;">￥{{item.allamount}}</span>
                </div>
              </div>
              <div>
                <el-table
                  :data="item.order_good"
                  :span-method="prop=>returnRequestSpanMethod3(prop,item.order_good.length)"
                  class="order-goods"
                >
                  <el-table-column prop="spu_name" align="center" border label width="300px">
                    <template slot-scope="scope">
                      <div style="display:flex">
                        <div >
                          <div style="display: flex;flex-direction: column;text-align: left;">
                            <div style="display:flex;font-size:12px;">
                              <div
                                style="margin-right:5px"
                              >{{scope.row.order_good_name}}</div>
                              <div style="font-size: 20px;">|</div>
                              <div style="margin-left:5px">{{scope.row.good_banane}}</div>
                            </div>
                            <div
                              style="text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;white-space:pre;  "
                            >{{scope.row.order_good_spec}}</div>
                          </div>
                        </div>
<!--                        <div>-->
<!--                          <el-image-->
<!--                            v-if="scope.row.pic!=''&&scope.row.pic!=null"-->
<!--                            :src="scope.row.pic"-->
<!--                            style="width:50px"-->
<!--                          ></el-image>-->
<!--                          <el-image v-else src="static/image/error.png" style="width:50px"></el-image>-->
<!--                        </div>-->
<!--                        <div style="width: 68%;margin-left:5%">-->
<!--                          <div style="display: flex;flex-direction: column;text-align: left;">-->
<!--                            <div style="display:flex;font-size:12px;">-->
<!--                              <div-->
<!--                                style="margin-right:5px"-->
<!--                              >{{scope.row.order_good_name}}</div>-->
<!--                              <div style="font-size: 20px;">|</div>-->
<!--                              <div style="margin-left:5px">{{scope.row.good_banane}}</div>-->
<!--                            </div>-->
<!--                            <div-->
<!--                              style="white-space: pre;text-align:left!important;width:100%;font-family: Courier New;font-size: 13px;    margin-left: 20px;"-->
<!--                            >{{scope.row.order_good_spec}}</div>-->
<!--                          </div>
                        </div>-->
                      </div>
                    </template>
                  </el-table-column>
<!--                  <el-table-column class="center-td" align="center" label width="50px">-->
<!--                    <template slot-scope="scope">-->
<!--                      <div>X{{scope.row.order_good_qty}}</div>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column align="center"  >
                    <template slot-scope="scope">
                      <div>{{scope.row.order_good_qty}}</div>
                    </template>
                  </el-table-column>
<!--                  <el-table-column class="center-td" align="center" width="120">-->
<!--                    <template slot-scope="scope">-->
<!--                      <div style="float: right;">{{scope.row.tax_price}}</div>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column align="center" >
                    <template slot-scope="scope">
                      <div style="float: right;">{{scope.row.tax_price}}</div>
                    </template>
                  </el-table-column>
                  <el-table-column  show-overflow-tooltip align="center" width="120px">
                    <template slot-scope="scope">
                      <span>{{scope.row.ware_name}}</span>
                    </template>
                  </el-table-column>
<!--                  <el-table-column class="center-td" align="center" label>-->
<!--                    <template slot-scope="scope">-->
<!--                      <span>{{scope.row.ware_name}}</span>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column align="center" >
                    <template >
                      <div v-if="item.order_status.id == '1'">
                        <small>待审核</small>
                      </div>
                      <div v-if="item.order_status.id == '2'">
                        <small>待出库</small>
                      </div>
                      <div v-if="item.order_status.id == '3'">
                        <small>已出库</small>
                      </div>
                      <div v-if="item.order_status.id == '4'">
                        <small>已完成</small>
                      </div>
                      <div>
                        <div
                          style="color:#C39A58;cursor: pointer;"
                          @click="orderDetail(item)"
                        >订单详情</div>
                      </div>
                    </template>
                  </el-table-column>
<!--                  <el-table-column class="center-td" align="center" label width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                      <div v-if="item.order_status.id == '1'">-->
<!--                        <small>待审核</small>-->
<!--                      </div>-->
<!--                      <div v-if="item.order_status.id == '2'">-->
<!--                        <small>待出库</small>-->
<!--                      </div>-->
<!--                      <div v-if="item.order_status.id == '3'">-->
<!--                        <small>已出库</small>-->
<!--                      </div>-->
<!--                      <div v-if="item.order_status.id == '4'">-->
<!--                        <small>已完成</small>-->
<!--                      </div>-->
<!--                      <div>-->
<!--                        <div style="color:#C39A58;cursor: pointer;" @click="orderDetail(item)">订单详情</div>-->
<!--                        &lt;!&ndash; <strong style="cursor: pointer;" @click="orderDetail(item)">订单详情</strong> &ndash;&gt;-->
<!--                      </div>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
<!--                  <el-table-column class="center-td" align="center" label="仓库" width="110">-->
<!--                    <template slot-scope="scope">-->
<!--                      <el-button-->
<!--                        type="warning"-->
<!--                        plain-->
<!--                        round-->
<!--                        size="mini"-->
<!--                        @click="option_order(item)"-->
<!--                      >再来一单</el-button>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column align="center"  width="130px">
                    <template>
                      <el-button
                        type="warning"
                        plain
                        round
                        size="mini"
                        @click="option_order(item)"
                      >再来一单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
        <div>
          <el-pagination
            @size-change="handleSizeChange_my_order"
            @current-change="handleCurrentChange_my_order"
            :current-page.sync="currentPage_my_order"
            :page-size="pageSize_my_order"
            layout="total,prev, pager, next, jumper"
            :total="total_my_order"
            v-if="total_my_order"
          ></el-pagination>
        </div>
      </div>
      <!-- 我的收藏 -->
      <div
        class="main-right"
        v-show="currentStatus == -1 && show != 1 && detail_order != 1 && my_deliveryAddress != 1 && collect_list == 1 && my_pipeline !=1 "
      >
        <div class="right-page my_collection">
          <div>
            <h4 class="personal-h4">我的收藏</h4>
          </div>
          <hr class="personal-hr" />
          <div class="red-solid"></div>
          <div class="content-row">
            <div class="y-right-main-center">
              <div class="y-right-main-center-list">
                <div
                  class="personal-goods"
                  v-for="(item,index) in my_collection"
                  :key="index"
                  style="margin:0 1%;margin-top:1%;position: relative;"
                >

                  <div class="u-list">
                    <div class="u-list-img">
                      <img
                        :src="item.pic"
                        class="u-list-img-img"
                        v-if="item.pic!='' && item.pic!= null"
                      />
                      <el-image v-else src="static/image/error.png" style="width: 85%;"></el-image>
                    </div>
                    <div class="price-div z-color">￥ {{item.good_price}}</div>
                    <div class="goodName-div">{{item.good_name}}</div>
                    <div class="spec-div" style="white-space: pre;">{{item.good_spec}}</div>
                    <div class="goods-btn">
                      <el-button
                        @click="good_cart(item)"
                        type="warning"
                        plain
                        round
                        size="small"
                        class="join-cart"
                      >加入购物车</el-button>
                      <!--                    style="position: absolute;right:5px;"-->
                      <el-button
                        type="warning"
                        size="small"
                        round
                        plain
                        @click="collectionGood(item.good_erpid)"
                        class="join-cart-sc"
                      >
                        <i class="fa fa-heart button-icon" plain aria-hidden="true"></i>
                        取消收藏
                      </el-button>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 地址管理 -->
      <div
        class="main-right"
        v-show="currentStatus == -1 && show != 1 && detail_order != 1  && collect_list != 1 && my_deliveryAddress == 1 && my_pipeline !=1 "
      >
        <div class="right-page received_address">
          <el-dialog :visible.sync="addressShow" title="新增/修改地址" width="40%">
            <div style="display: inline-block;padding-right: 10%;">
              <div class="content-row">
                <div class="col-12 col-6-dialog">
                  <div class="col-3">
                    <span>
                      <span class="redstar">*</span>收货人姓名
                    </span>
                  </div>
                  <div class="col-9">
                    <el-input v-model="name" size="medium" placeholder="不能为昵称,X先生,X小姐等" clearable>
                      <i
                        slot="suffix"
                        class="el-input__icon el-icon-chat-dot-round"
                        title="电话确认收货人不在现场指定人员代收货"
                      ></i>
                    </el-input>
                  </div>
                </div>
                <div class="col-12 col-6-dialog">
                  <div class="col-3">
                    <span>
                      <span class="redstar">*</span>手机号码
                    </span>
                  </div>
                  <div class="col-9">
                    <el-input
                      type="text"
                      v-model="phone"
                      size="medium"
                      placeholder="请填写手机号码"
                      validate-event
                      onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
                      show-word-limit
                      clearable
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="content-row">
                <div class="col-12 col-6-dialog">
                  <div class="col-3">
                    <span>
                      <span class="redstar">*</span>所在地区
                    </span>
                  </div>
                  <div class="col-3">
                    <el-select
                      v-model="province"
                      @change="selectProvince()"
                      filterable
                      size="small"
                      placeholder="请选择省份"
                    >
                      <el-option
                        v-for="item in province_data"
                        :key="item.id"
                        :label="item.cityname"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="col-3">
                    <el-select v-model="city" size="small" filterable @change="selectCity()" placeholder="请选择市">
                      <el-option
                        v-for="item in city_data"
                        :key="item.id"
                        :label="item.cityname"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="col-3">
                    <el-select
                      v-model="area"
                      filterable
                      size="small"
                      @change="selectArea()"
                      placeholder="请选择区/县"
                    >
                      <el-option
                        v-for="item in area_data"
                        :key="item.id"
                        :label="item.cityname"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="content-row">
                <div class="col-12 col-6-dialog">
                  <div class="col-3">
                    <span>
                      <span class="redstar">*</span>详细地址
                    </span>
                  </div>
                  <div class="col-9">
                    <el-input type="textarea" autosize placeholder="请输入内容" v-model="detail_address"></el-input>
                  </div>
                </div>
              </div>
              <div class="content-left-row default-address-row">
                <el-checkbox v-model="checked">设为默认地址</el-checkbox>
              </div>
              <div style="text-align: center;">
                <el-button @click="btnSubmit()" type="primary" class="btn_class" plain size="medium">确认</el-button>
                <el-button @click="btnReturn()" type="info" class="btn_class" plain size="medium">返回</el-button>
              </div>
            </div>
          </el-dialog>
          <div class="content-left-row">
            <span class="span-title">地址管理</span>
          </div>
          <div class="content-center-row addaddress">
            <div class="add-address gray-font-row" @click="addReceivedAddress()">
              <span>+</span>
              <span>新增地址</span>
            </div>
          </div>
          <div class="content-left-row saved-address">
            <span>
              <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
              已保存了{{received_address_data.length}}条地址,还能保存{{20 - this.received_address_data.length}}条地址
            </span>
          </div>
          <div class="content-row data-row">
            <el-table :data="received_address_data" :header-cell-style="rowStyle" border>
              <el-table-column prop="receiver" label="收货人"></el-table-column>
              <el-table-column label="联系电话/手机">
                <template slot-scope="scope">
                  <span>{{scope.row.tel}}</span>
                  <span>{{scope.row.phone}}</span>
                </template>
              </el-table-column>
              <el-table-column label="所在地区">
                <template slot-scope="scope">
                  <span>{{scope.row.province.name}}</span>
                  <span>{{scope.row.city.name}}</span>
                  <span>{{scope.row.area.name}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="addr" label="详细地址"></el-table-column>
              <el-table-column label="操作" class="center-td">
                <template slot-scope="scope">
                  <span @click="editAddress(scope.row.id)" class="edit-span">修改</span>|
                  <span @click="delAddress(scope.row.id)" class="del-span">删除</span> |
                  <span
                    :class="scope.row.is_default == 1 ? 'default_address' : 'no-default-address'"
                    @click="setDefaultAddress(scope.row.id,scope.row.is_default)"
                  >{{scope.row.is_default == 1 ? '默认地址' : '设为默认'}}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <!-- 注册信息 -->
      <div
        class="main-right"
        　
        v-show="currentStatus == -1 && show != 1 && detail_order != 1  && my_deliveryAddress != 1 && register == 1  && my_pipeline !=1 "
      >
        <el-dialog :visible.sync="invoicesShow" title="修改开票信息">
          <div class="content-row">
            <div class="col-6 col-6-dialog">
              <div class="col-4">
                <span style="float: right;margin-right:10px;">
                  <span class="redstar">*</span>发票抬头
                </span>
              </div>
              <div class="col-8">
                <el-input v-model="titlename" size="medium" placeholder="发票抬头" clearable>
                </el-input>
              </div>
            </div>

            <div class="col-6 col-6-dialog">
              <div class="col-4">
                <span style="float: right;margin-right:10px;">
                  <span class="redstar">*</span>发票类型
                </span>
              </div>
              <div class="col-8">
                <el-select v-model="value" placeholder="请选择" style="width:100%;">
                  <el-option key="1" label="增值税专用发票" :value="1"></el-option>
                  <el-option key="2" label="增值税普通发票" :value="2"></el-option>
                </el-select>
              </div>
            </div>

            <div class="col-6 col-6-dialog" style="margin-top:15px;">
              <div class="col-4">
                <span style="float: right;margin-right:10px;">
                  <span class="redstar">*</span>注册地址
                </span>
              </div>
              <div class="col-8">
                <el-input v-model="invoiceAddress" size="medium" placeholder="注册地址" clearable>
                </el-input>
              </div>
            </div>
            <div class="col-6 col-6-dialog" style="margin-top:15px;">
              <div class="col-4">
                <span style="float: right;margin-right:10px;">
                  <span class="redstar">*</span>注册电话
                </span>
              </div>
              <div class="col-8">
                <el-input
                  type="text"
                  v-model="invoiceTel"
                  size="medium"
                  placeholder="请填写手机号码"
                  validate-event
                  onkeyup="value=value.replace(/[^\d\-\d]/g,'')"
                  show-word-limit
                  clearable
                ></el-input>
              </div>
            </div>
            <div class="col-6 col-6-dialog" style="margin-top:15px;">
              <div class="col-4">
                <span style="float: right;margin-right:10px;">
                  <span class="redstar">*</span>开户银行
                </span>
              </div>
              <div class="col-8">
                <el-input v-model="invoiceBack" size="medium" placeholder="开户银行" clearable>
                </el-input>
              </div>
            </div>
            <div class="col-6 col-6-dialog" style="margin-top:15px;">
              <div class="col-4">
                <span style="float: right;margin-right:10px;">
                  <span class="redstar">*</span>银行账号
                </span>
              </div>
              <div class="col-8">
                <el-input v-model="invoiceAccount" size="medium" placeholder="银行账号" clearable>
                </el-input>
              </div>
            </div>
            <div class="content-row">
              <div class="col-12 col-12-dialog">
                <div class="col-2">
                  <span style="float: right;margin-right:10px;">
                    <span class="redstar">*</span>统一社会信用代码
                  </span>
                </div>
                <div class="col-9">
                  <el-input
                    v-model="invoice_unified_social_code"
                    size="medium"
                    placeholder="统一社会信用代码"
                    clearable
                  >
                  </el-input>
                </div>
              </div>
            </div>
            <div class="content-center-row">
              <el-button size="mini" type="primary" plain @click="btnInvoicesSubmit()">确认</el-button>
              <el-button size="mini" type="info" plain  @click="btnReturn()">返回</el-button>
            </div>
            <div class="content-left-row" style="margin-top:15px;text-align: center;color:red">
              <span>审核结果将以客服形式告知，请注意查收。</span>
            </div>
          </div>
        </el-dialog>

        <!-- <div class="content-left-row">
          <span
            class="span-title"
            style="cursor: pointer;"
            :class=" { span_title : invoicebill_show == 1 } "
            @click="invoiceBill1(1)"
          >开票信息</span> |
          <span
            class="span-title"
            style="cursor: pointer;"
            :class=" { span_title : invoicebill_show == 2 } "
            @click="invoiceBill1(2)"
          >注册信息</span>
        </div>-->
        <div class>
          <h4 class="personal-h4">开票信息</h4>
        </div>
        <hr class="personal-hr" />
        <div class="red-solid"></div>
        <div class="content-row" v-if="invoicebill_show == 1">
          <div class="d-region" style="padding:15px 15px 15px 50px;">
            <p>
              发票抬头：
              <span v-if="invoicebill !=null">{{invoicebill.title}}</span>
            </p>
            <p>
              发票类型：
              <span v-if="invoicebill !=null">
                <span v-if="invoicebill.finvoice_type !=null ">{{invoicebill.finvoice_type.name}}</span>
              </span>
            </p>
            <p>
              统一社会信用代码：
              <span v-if="invoicebill !=null">{{invoicebill.unified_social_code}}</span>
            </p>
            <p>
              注册地址：
              <span v-if="invoicebill !=null">{{invoicebill.addr}}</span>
            </p>
            <p>
              注册电话：
              <span v-if="invoicebill !=null">{{invoicebill.tel}}</span>
            </p>
            <p>
              开户银行：
              <span v-if="invoicebill !=null">{{invoicebill.bank}}</span>
            </p>
            <p>
              银行账号：
              <span v-if="invoicebill !=null">{{invoicebill.account}}</span>
            </p>
            <button
              type="button"
              class="d-button-edit"
              style="cursor: pointer;"
              @click="changInvoices(invoicebill)"
            >修改</button>
          </div>
        </div>
        <div class="content-row" v-else>
          <div class="d-region" v-if=" customRegister != null ">
            <p>
              公司名称：
              <span>{{customRegister.company}}</span>
            </p>
            <p>
              账号：
              <span>{{customRegister.account}}</span>
            </p>
            <p>
              联系人：
              <span>{{customRegister.contacts}}</span>
            </p>
            <p>
              手机号码：
              <input
                class="d-input-password"
                disabled
                type="text"
                name="password"
                id
                :value="customRegister.tel"
              />
              <span style="cursor: pointer;color:#D1B280;" @click="changTel()">更换</span>
            </p>
            <p>
              账号密码：
              <input
                class="d-input-password"
                disabled
                type="password"
                name="password"
                id
                :value="customRegister.tel"
              />
              <span style="cursor: pointer;color:#D1B280;" @click="changPassword()">修改</span>
            </p>
          </div>
        </div>
      </div>
      <!-- 流水记录 -->
      <div
        class="main-right"
        　
        v-show="currentStatus == -1 && show != 1 && detail_order != 1  && my_deliveryAddress != 1 && register != 1  && my_pipeline ==1 "
      >
        <div class="right-page flow_record">
          <div class="content-left-row f-16">
            <span class="span-title">流水记录</span>
          </div>
          <div class="content-row">
            <div class="col-6">
              <div class="record-pay">
                <div class="col-6" style="margin-top:10%">
                  <div class="conotent-left-row">付款总计(元)</div>
                  <div class="content-row"></div>
                  <div class="conotent-left-row f-15 f-17">￥{{sumpaysum}}</div>
                </div>
                <div class="col-6" style="margin-top:8%">
                  <img src="static/image/qianbao.png" style="width:40%;height:80%" alt />
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="record-debit">
                <div class="col-6" style="margin-top:10%">
                  <div class="conotent-left-row">扣款总计(元)</div>
                  <div class="content-row"></div>
                  <div class="conotent-left-row f-15 f-17">￥{{suminvest}}</div>
                </div>
                <div class="col-6" style="margin-top:8%">
                  <img src="static/image/libao.png" style="width:40%;height:80%" alt />
                </div>
              </div>
            </div>
          </div>
          <div class="content-row">
            <el-table
              :data="flow_record_data"
              border
              :header-cell-style="rowStyle"
              class="table-attr"
            >
              <el-table-column
                label="业务日期"
                width="180"
                sortable
                show-overflow-tooltip
                prop="created_t"
              ></el-table-column>
              <el-table-column class="center-td" label="单据类型" sortable prop="type.name"></el-table-column>
              <el-table-column class="center-td" width="150" label="单据编号" sortable prop="pay_order"></el-table-column>
              <el-table-column class="center-td" label="账户类型" sortable prop="account.name"></el-table-column>
              <el-table-column class="center-td" label="扣款" align="right" sortable prop="paysum"></el-table-column>
              <el-table-column class="center-td" label="付款" align="right" sortable prop="invest"></el-table-column>
              <el-table-column class="center-td" label="余额" align="right" sortable prop="balance"></el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange_flow_record"
              @current-change="handleCurrentChange_flow_record"
              :current-page.sync="currentPage_flow_record"
              layout="total,prev, pager, next, jumper"
              :total="total_flow_record"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="item-content"></div>
  </div>
  </div>
</template>
<script src="https://cdn.jsdelivr.net/npm/vue/dist/vue.js"></script>
<script>
import { debuglog } from "util";
// var id = this.$route.query.id;
// ddldld
import Unit from "@/assets/js/Unit";
export default {
  name: "Good",
  components: {},
  data() {
    return {
      deliveryMode: "",
      show_left: true, //显示左侧菜单
      my_order_list: [
        { name: "全部订单", status: "" },
        { name: "待审核", status: "1" },
        { name: "待出库", status: "2" },
        { name: "已出库", status: "3" },
        { name: "已完成", status: "4" }
      ],
      good_list: [],
      order_data: [],
      my_order_data: [], //5种状态
      my_collection: [], //收藏
      received_address_data: [], //收货地址
      return_request_data: [], //退货申请
      add_return_request_data: [], //新增退货申请列表
      order_detail_data: [], //订单详情
      check_price_data: [], //核价单
      flow_record_data: [], //流水记录
      reciprocal_bills_data: [], //往来对账单
      photo_image: "/static/image/photo.png",
      addShow: false,

      /*所有分页开始*/
      currentPage: 1,
      pageSize: 10,
      total: 0,

      //个人中心
      credit_balance: "",
      account_balance: "",

      //我的订单
      currentPage_my_order: 1,
      pageSize_my_order: 10,
      total_my_order: 0,
      //流水记录
      currentPage_flow_record: 1,
      pageSize_flow_record: 10,
      total_flow_record: 0,

      /*所有分页结束*/

      currentStatus: -1,
      keyword: "",
      isCurrentStatus: "1",
      logisticsStatus: false,

      srcList: ["/index/static/image/good.jpg"],

      rowStyle: {
        height: "3rem",
        color: "#575757",
        background: "#E9E9E9",
        "text-align": "center"
      },
      currentIndex: 0,
      //新增地址弹窗 + 参数
      addressShow: false,
      name: "",
      phone: "",
      mail: "",
      tel: "",
      project_name: "",
      customer_name: "",
      province: "",
      city: "",
      area: "",
      detail_address: "",
      checked: false,
      province_name: "",
      city_name: "",
      area_name: "",

      //省+市+区数据
      province_data: [],
      city_data: [],
      area_data: [],

      //订单详情参数
      ApplicationMode: 1, //临时额度申请方式
      ApprovalAmount: "", //审批金额
      ValidityDate: "", //到期日期
      PreferAmount: "", //优惠金额
      AllAmount: "", //结算金额
      Allamount: "",
      DeliveryType: "", //配送方式
      DeliveryPayType: "", //付款方式
      Note: "", //备注
      Operator: "", //经办人
      Address: "", //地址
      Receiver: "", //收货人
      Phone: "", //手机号
      invoice_info: [],
      invoicesite_info: [],

      loading: true,
      currentPageName: "个人中心",
      currentChildrenPageName: "",

      sumpaysum: "", //付款总计
      suminvest: "", //扣款总计

      dialogVisible: false,
      againCurrentOrder: "",

      all_weight: "",

      //往来对帐单
      startDate: "",
      endDate: "",

      //新增退货申请参数
      order_code_list: [], //订单编号列表
      add_return_request_num: 1,
      new_order_code: "",
      new_refund_reason: "",
      refund_reason: "", //退款原因
      new_project_name: "", //新增退货项目名称
      new_customer_name: "", //新增退货顾客名称
      new_remark: "", //新增退款说明
      num: 1,
      sku_code: [],
      good_qty: [],

      //上传图片
      dialogImageUrl: "",
      dialogVisible_img: false,
      // disabled: false,

      isAdd: false,
      id: [],

      check_data: [], //选中的数据

      // 订单列表
      show: 1,
      order_all: true,
      detail_order: 1 /* 订单详情 */,
      my_deliveryAddress: 1 /* 收货地址 */,
      collect_list: 1 /* 我的收藏 */,
      register: 1 /* 注册信息 */,
      my_pipeline: 1 /* 流水记录 */,

      // 注册信息
      customInfo: "",
      invoicebill: "", //发票信息
      customRegister: "", //注册信息
      invoicebill_show: 1, //显示开票
      tellShow: false, //更改手机号
      telname: "",
      telphone: "",
      tel_detail_address: "",
      passwordShow: false, //注册信息 修改账号密码

      //注册信息 修改密码
      sms: "",
      passwordfp: "",
      sendAuthCode: "",
      auth_timetimer: 0,
      sendAuthCode: true,
      passwordphone: "",
      passwordfp1: "",
      passwordfp2: "",
      // 注册信息 修改开票信息
      invoicesShow: false,
      titlename: "", //发票抬头
      value: "", // 发票类型
      invoiceAddress: "", //注册地址
      invoiceTel: "", //注册电话
      invoiceBack: "", // 开户银行
      invoiceAccount: "", //银行账号
      invoice_unified_social_code: "", //统一社会信用代码
      invoice_id: "", //id
      credit: "", // 支付方式

      imageUrl: "static/image/error.png",
      fileList: [],
      spanArr: [],
      pos: 0,
      spanArr1: [],
      pos1: 0,
      current_checked_menu: ['1'],
      loading: true,

      logistics_code: "",
      order_index: ""
    };
  },
  mounted() {
    this.view();
    let that = this;
    Unit.$on("closeMenu", function(i) {
      that.closeMenu();
    });
  },
  watch: {
    $route: function(to, from) {
      // 拿到目标参数 to.query.id 去再次请求数据接口
      this.view(to.query.page_name);
    }
  },
  methods: {
    view(page_name) {
      page_name =
        this.$route.query.page_name == undefined
          ? page_name
          : this.$route.query.page_name;
      if (page_name != undefined && page_name == "我的收藏") {
        this.my_collect();
        // this.current_checked_menu = "2-1";
      }
      if (page_name != undefined && page_name == "我的订单") {
        this.lookOrderbyStatus("", 0);

        // this.current_checked_menu = "1-0";
      }
      if (page_name != undefined && page_name == "个人中心") {
        // this.current_checked_menu = "";
        this.handleClose("1");
        this.getPersonalInfo();
      }
      this.getMyCollection();
      this.getGoodInfo();
      this.invoiceBill();
    },
    checkCurrentPage(page_name) {},

    //个人中心 获取个人中心数据
    getPersonalInfo() {
      this.show = 1;
      this.currentStatus = -1;
      this.detail_order = 2;
      this.my_deliveryAddress = 2;
      this.register = 2;
      this.my_pipeline = 2;
      this.collect_list = 2;
      this.keyword = "";
    },
    //我的订单 获取商品信息 订单信息
    getGoodInfo() {
      this.$axios({
        method: "post",
        url: "/index/order/search",
        params: {
          type: "page",
          status: this.currentStatus,
          keyword: this.keyword,
          pagesize: this.pageSize_my_order,
          page: this.currentPage_my_order
        }
      }).then(res => {
        this.my_order_data = res.data.data.data.data;
        this.total_my_order = res.data.data.data.total;
        let good_list = [];
        let my_order_data = [...this.my_order_data];
        let g;
        for (g in my_order_data) {
          if(my_order_data[g].order_good){
            good_list.push(my_order_data[g].order_good);
          }
        }

        this.good_list = [...good_list];
        // console.log(this.good_list)
        this.getRowSpan(this.good_list);
        this.loading = false;
      });
    },

    // 计算需要合并的单元格
    getSpanData(data) {
      // 存放计算好的合并单元格的规则
      this.spanData = [];
      for (var i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanData.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (data[i].order_id === data[i - 1].order_id) {
            // data[i].realOpenDate === data[i - 1].realOpenDate
            this.spanData[this.pos] += 1;
            this.spanData.push(0);
          } else {
            this.spanData.push(1);
            this.pos = i;
          }
        }
      }
    },

    view_co() {
      this.currentStatus = this.order_index;
    },
    // 我的订单 取消订单
    del_order(item) {
      this.$confirm("确认要取消吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/index/order/delete",
            params: {
              id: item.id
            }
          }).then(res => {
            this.$message1("删除成功！");
            this.view();
          });
        })
        .catch(() => {});
    },
    handleAvatarSuccess(res, file, fileList) {
      this.imageUrl = res.data;
      this.$axios({
        method: "post",
        url: "/index/customer/set_favatar",
        params: {
          pic: this.imageUrl
        }
      }).then(res => {
        this.$message1("上传成功！");
      });
    },
    //我的收藏
    getMyCollection() {
      this.$axios({
        method: "post",
        url: "/index/Collection/index",
        params: {}
      })
        .then(res => {
          this.my_collection = res.data.data.data.data;
        })
        .catch(err => {});
    },
    //收货地址
    getAddress() {
      this.$axios({
        method: "post",
        url: "index/Customer_addr/index",
        params: {}
      })
        .then(res => {
          this.received_address_data = res.data.data.list;
        })
        .catch(err => {});
      this.$axios({
        method: "post",
        url: "index/customer_addr/city",
        params: {}
      })
        .then(res => {
          this.province_data = res.data.data;
        })
        .catch(err => {});
    },
    //流水记录
    getFlowRecord() {
      this.$axios({
        method: "post",
        url: "/index/flow/search",
        params: {
          pagesize: 10,
          page: this.currentPage_flow_record
        }
      })
        .then(res => {
          this.flow_record_data = res.data.data.data.data;
          this.total_flow_record = res.data.data.data.total;
          this.sumpaysum = res.data.data.statistics.pay_money;
          this.suminvest = res.data.data.statistics.return_money;
        })
        .catch(err => {});
    },
    // 订单详情返回
    backMenu() {},
    // 流水记录
    pipeline_record() {
      this.my_pipeline = 1;
      this.show = 2;
      this.currentStatus = -1;
      this.detail_order = 2;
      this.my_deliveryAddress = 2;
      this.collect_list = 2;
      this.register = 2;
      this.getFlowRecord();
    },
    // 注册信息
    my_register() {
      this.show = 2;
      this.currentStatus = -1;
      this.detail_order = 2;
      this.my_deliveryAddress = 2;
      this.collect_list = 2;
      this.my_pipeline = 2;
      this.register = 1;
      this.invoiceBill();
    },
    // 我的收藏
    my_collect() {
      this.show = 2;
      this.currentStatus = -1;
      this.detail_order = 2;
      this.my_deliveryAddress = 2;
      this.register = 2;
      this.my_pipeline = 2;
      this.collect_list = 1;
      this.getMyCollection();
    },
    // 地址管理
    deliveryAddress() {
      this.show = 2;
      this.currentStatus = -1;
      this.detail_order = 2;
      this.collect_list = 2;
      this.register = 2;
      this.my_pipeline = 2;
      this.my_deliveryAddress = 1;
      this.getAddress();
    },
    //订单详情
    orderDetail(orderCode) {
      this.show = 2;
      this.currentStatus = -1;
      this.my_deliveryAddress = 2;
      this.register = 2;
      this.collect_list = 2;
      this.my_pipeline = 2;
      this.detail_order = 1;
      this.$axios({
        method: "post",
        url: "index/order/order_info",
        params: {
          id: orderCode.id
        }
      })
        .then(res => {
          // this.show_left = false;
          this.order_detail_data = res.data.data.data.data[0];
          this.deliveryMode = this.order_detail_data.delivery.name;
          let order_list = this.order_detail_data.order_good;
          for (var i = 0; i < order_list.length; i++) {
            if (i === 0) {
              this.spanArr1.push(1);
              this.pos1 = 0;
            } else {
              // 判断当前元素与上一个元素是否相同（line为标记）
              if (order_list[i].order_sn === order_list[i - 1].order_sn) {
                this.spanArr1[this.pos] += 1;
                this.spanArr1.push(0);
              } else {
                this.spanArr1.push(1);
                this.pos1 = i;
              }
            }
          }

          let weightz = 0;
          for (let i = 0; i < order_list.length; i++) {
            weightz =
              parseFloat(order_list[i].total_weight) + parseFloat(weightz);
          }
          this.all_weight = weightz.toFixed(4);
          this.PreferAmount = this.order_detail_data.prefer_amount;
          this.Allamount = this.order_detail_data.allamount;
          this.AllAmount = this.order_detail_data.pay_amount; //实付金额(含运费)
          this.Address = this.order_detail_data.addr; //收货地址
          this.Receiver = this.order_detail_data.receiver; //收货地址
          this.Phone = this.order_detail_data.tel; //收货地址

          this.invoice_info = this.order_detail_data.invoice_info?JSON.parse(this.order_detail_data.invoice_info):{};
          this.invoicesite_info = this.order_detail_data.invoicesite_info?JSON.parse(
            this.order_detail_data.invoicesite_info
          ):{};

          let g;
          let logistics = [];
          for (const g in this.order_detail_data.logistics) {
            logistics.push(this.order_detail_data.logistics[g].code);
          }
          this.logistics_code = logistics.join(" ； ");
        })
        .catch(err => {});
    },
    collectionGood(good_erpid,index) {
            this.$axios({
              method: "post",
              url: "/index/collection/del",
              params: {
                good_erpid: good_erpid
              }
            })
              .then(res => {
                if (res.data.status == "ok") {
                  this.$message1("取消收藏成功!");
                  this.my_collection.splice(index,1);
                  // this.good_info.data.collect = 0;
                }
              })
              .catch(err => {
                // this.$message(res.data.msg);
              });
    },
    //根据状态获取订单数据
    lookOrderbyStatus(status, index) {
      if (index == 0) {
        this.show = null;
        this.currentStatus = "";
      } else {
        this.currentStatus = index;
        this.order_index = index;
      }
      this.getGoodInfo();
    },
    //新增地址
    addReceivedAddress() {
      this.name = "";
      this.phone = "";
      this.tel = "";
      this.province = "";
      this.city = "";
      this.area = "";
      this.detail_address = "";
      this.checked = false;
      this.addressShow = true;
      this.isAdd = true;
    },
    btnSubmit() {
      var data = {};
      if (this.isAdd) {
        data = {
          province: this.province,
          city: this.city,
          area: this.area,
          receiver: this.name,
          addr: this.detail_address,
          phone: this.phone,
          tel: this.tel,
          is_default: this.checked == true ? 1 : false
        };
        this.$axios({
          method: "post",
          url: "/index/Customer_addr/add",
          params: {
            data: data
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1(res.data.msg);
              this.getAddress();
              this.addressShow = false;
            } else {
              this.$message1(res.data.msg);
            }
          })
          .catch(err => {
            this.$message1(err.response.data.msg);
          });
      } else {
        data = {
          id: this.id,
          province: this.province,
          city: this.city,
          area: this.area,
          receiver: this.name,
          addr: this.detail_address,
          phone: this.phone,
          tel: this.tel,
          is_default: this.checked == true ? 1 : false
        };
        this.$axios({
          method: "post",
          url: "/index/Customer_addr/save",
          params: {
            data: data
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1("修改成功!");
              this.getAddress();
              this.addressShow = false;
            } else {
              this.$message1(res.data.msg);
            }
          })
          .catch(err => {
            this.$message1(err.response.data.msg);
          });
      }
    },

    // 加入购物车
    good_cart(e) {
      if (e.id != "") {
        this.$router.push({
          path: "/GoodDetail/index",
          query: { id: e.id }
        });
      }
    },

    // 再来一单
    option_order(e) {
      this.$axios({
        method: "post",
        url: "/index/order/again",
        params: {
          code: e.order_sn
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$message1(res.data.msg);
            this.$router.push({
              path: "/Cart/index"
            });
          } else {
            this.$message1(res.data.msg);
          }
        })
        .catch(err => {
          this.$message1(err.response.data.msg);
        });
    },

    btnReturn() {
      this.addressShow = false;
      this.tellShow = false;
      this.invoicesShow = false;
      this.passwordShow = false;
    },

    // 开票 发票 信息
    invoiceBill() {
      this.$axios({
        method: "post",
        url: "/index/customer/get_register_info",
        params: {}
      })
        .then(res => {
          this.invoicebill = res.data.data.invoices;
          this.customRegister = res.data.data.customRegister;
          this.customInfo = res.data.data.customInfo.credit;
          this.imageUrl = res.data.data.customInfo.favatar;
        })
        .catch(err => {});
    },
    // 注册信息 显示
    invoiceBill1(e) {
      this.invoicebill_show = e;
      if (e == 1) {
        this.invoiceBill();
        return;
      }
      if (e == 2) {
        this.invoiceBill();
        return;
      }
    },
    // 注册信息 修改开票信息
    changInvoices(e) {
      if (this.invoicebill == null) {
      } else {
        this.invoice_id = e.id;
        this.titlename = e.title;
        this.invoiceAddress = e.addr;
        this.invoiceTel = e.tel;
        this.invoiceBack = e.bank;
        this.value = e.finvoice_type.type;
        this.invoiceAccount = e.account;
        this.invoice_unified_social_code = e.unified_social_code;
      }
      this.invoicesShow = true;
    },
    // 注册信息 修改手机号
    changTel() {
      this.tellShow = true;
    },
    // 注册信息 修改账号密码
    changPassword() {
      this.passwordShow = true;
    },

    // 注册信息 修改发票信息
    btnInvoicesSubmit(e) {
      if (this.invoicebill == null) {
        this.$axios({
          method: "post",
          url: "/index/Invoices/update",
          params: {
            // id: this.invoice_id,
            title: this.titlename,
            addr: this.invoiceAddress,
            tel: this.invoiceTel,
            bank: this.invoiceBack,
            account: this.invoiceAccount,
            finvoice_type: +this.value,
            unified_social_code: this.invoice_unified_social_code
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1("修改成功!");
              this.invoiceBill();
              this.invoicesShow = false;
            } else {
              this.$message1(res.data.msg);
            }
          })
          .catch(err => {
            this.$message1(err.response.data.msg);
          });
      } else {
        this.$axios({
          method: "post",
          url: "/index/Invoices/update",
          params: {
            id: this.invoice_id,
            title: this.titlename,
            addr: this.invoiceAddress,
            tel: this.invoiceTel,
            bank: this.invoiceBack,
            account: this.invoiceAccount,
            finvoice_type: +this.value,
            unified_social_code: this.invoice_unified_social_code
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1("修改成功!");
              this.invoiceBill();
              this.invoicesShow = false;
            } else {
              this.$message1(res.data.msg);
            }
          })
          .catch(err => {
            this.$message1(err.response.data.msg);
          });
      }
    },
    // 注册信息 修改手机号
    btnTelSubmit() {
      this.$axios({
        method: "post",
        url: "/index/customer/tel_update",
        params: {
          tel: this.telphone,
          contract: this.telname,
          content: this.tel_detail_address
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$message1("修改成功!");
            this.invoiceBill();
            this.telphone = "";
            this.telname = "";
            this.tel_detail_address = "";
            this.tellShow = false;
          } else {
            this.$message1(res.data.msg);
          }
        })
        .catch(err => {
          this.$message1(err.response.data.msg);
        });
    },

    // 注册信息 修改密码
    btnPasswordSubmit() {
      this.$axios({
        method: "post",
        url: "/index/customer/password_update",
        params: {
          tel: this.passwordphone,
          pwd: this.passwordfp1,
          confirm_password: this.passwordfp2
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.$message1("修改成功!");
            this.invoiceBill();
            this.passwordphone = "";
            this.passwordfp1 = "";
            this.passwordfp2 = "";
            this.sms = "";
            this.passwordShow = false;
          } else {
            this.$message1(res.data.msg);
          }
        })
        .catch(err => {
          this.$message1(err.response.data.msg);
        });
    },

    // 注册信息 更改短信验证码
    go_yz: function() {
      var _this = this;
      if (_this.passwordphone == "") {
        this.$message1("请填写手机号");
        return;
      }
      /* 获取验证码 */
      _this.sendAuthCode = false;
      _this.auth_timetimer = 60;
      var auth_timetimer = setInterval(() => {
        _this.auth_timetimer--;
        if (_this.auth_timetimer <= 0) {
          _this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
      this.$axios({
        method: "post",
        url: "/index/message/send",
        params: {
          mobile: this.passwordphone,
          _method: "post"
        }
      })
        .then(res => {
          if (res.status == "ok") {
            this.$message1(res.msg);
          } else {
            this.$message1(res.data.msg);
          }
        })
        .catch(err => {
          this.$message1(err.response.data.msg);
        });
    },

    //收货地址的省份市区
    selectProvince() {
      var that = this;
      this.province_data.forEach(function(currentVal, index) {
        if (that.province == currentVal.id) {
          that.city_data = currentVal.children;
          that.province_name = currentVal.cityname;
        }
      });
      this.city = "";
      this.area = "";
    },
    selectCity() {
      var that = this;
      this.city_data.forEach(function(currentVal, index) {
        if (that.city == currentVal.id) {
          that.area_data = currentVal.children;
          that.city_name = currentVal.cityname;
        }
      });
      this.area = "";
    },
    selectArea() {
      var that = this;
      this.area_data.forEach(function(currentVal, index) {
        if (that.area == currentVal.id) {
          that.area_name = currentVal.cityname;
        }
      });
    },
    closeMenu() {
      this.getPersonalInfo();
      this.handleClose("1");
      this.view();
    },
    handleClose(index) {
      this.$refs.menu.close(index);
    },
    getRowSpan(data) {
      data.forEach(e => {
        this.spanArr = [];
        for (var i = 0; i < e.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.index = 0;
          } else {
            // 判断当前元素与上一个元素是否相同
            if (e[i].order_id === e[i - 1].order_id) {
              this.spanArr[this.index] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.index = i;
            }
          }
        }
      });
    },
    returnRequestSpanMethod3(data,length) {
      const { row, column, rowIndex, columnIndex } = data
      if (columnIndex === 4 || columnIndex === 5) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: rowIndex===0?length:_row,
          colspan: _col
        };
      }
    },
    returnRequestSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 需要合并的列

      // [0, 1, 2].includes(columnIndex ), 表示合并前三列
      if (columnIndex === 4 || columnIndex === 5) {
        const _row = this.spanData[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },

    returnRequestSpanMethod1({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 7 || columnIndex == 9) {
        const _row = this.spanArr1[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col
        };
      }
    },
    delAddress(id) {
      this.$confirm("确定删除该吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "/index/Customer_addr/del",
            params: {
              id: id
            }
          })
            .then(res => {
              if (res.data.status == "ok") {
                this.$message1(res.data.msg);
                this.getAddress();
              }
            })
            .catch(err => {
              // this.$message(res.data.msg);
            });
        })
        .catch(() => {});
    },
    editAddress(id) {
      this.isAdd = false;
      this.id = id;
      this.$axios({
        method: "post",
        url: "/index/Customer_addr/index",
        params: {
          id: id
        }
      })
        .then(res => {
          if (res.data.status == "ok") {
            this.name = res.data.data.list[0].receiver;
            this.phone = res.data.data.list[0].phone;
            this.tel = res.data.data.list[0].tel;
            this.province = parseInt(res.data.data.list[0].province.id);
            this.selectProvince();
            this.city = parseInt(res.data.data.list[0].city.id);
            this.selectCity();
            this.area = parseInt(res.data.data.list[0].area.id);
            this.detail_address = res.data.data.list[0].addr;
            this.checked = res.data.data.list[0].is_default == 1 ? true : false;
            this.addressShow = true;
          }
        })
        .catch(err => {
          // this.$message(res.data.msg);
        });
    },
    setDefaultAddress(id, status) {
      if (status == 1) {
        return;
      } else {
        this.$axios({
          method: "post",
          url: "/index/Customer_addr/set_default",
          params: {
            id: id,
            status: 1,
            name: ""
          }
        })
          .then(res => {
            if (res.data.status == "ok") {
              this.$message1(res.data.msg);
              this.getAddress();
            }
          })
          .catch(err => {
            // this.$message(res.data.msg);
          });
      }
    },

    handleSizeChange(val) {},
    handleCurrentChange(val) {
      this.currentPage = val;
    },

    //我的订单
    handleSizeChange_my_order(val) {},
    handleCurrentChange_my_order(val) {
      this.currentPage_my_order = val;
      this.getGoodInfo();
    },
    //流水记录分页
    handleSizeChange_flow_record(val) {},
    handleCurrentChange_flow_record(val) {
      this.currentPage_flow_record = val;
      this.getFlowRecord();
    },
    // 查看物流
    click_logistics() {
      $("#logistics_dtaile").toggle();
    }
  }
};
</script>
<style lang="less" scoped>
#app {
  width: 100%;
  height: 100%;
  background: whitesmoke;
}
.item-content {
  width: 19%;
}
.main {
  padding-top: 15px;
  width: 100%;
  display: flex;
}

#logistics_dtaile {
  display: none;
}
.main {
  display: flex;
}
.main-left {
  width: 12%;
  min-width: 200px;
  margin-right: 1%;
  background: #fff;
  // box-shadow: 0px 0px 5px 1px #aaa;
  text-align: center;
  height: 400px;
}
.main-left .left-name {
  color: #c39a58;
  font-weight: bold;
  font-size: 13px;
  text-align: center;
}
.main-left .el-submenu .el-menu-item {
  min-width: 100%;
}

.y-left-size {
  font-size: 12px;
}
.left-order .el-button {
  border: none;
}
.credit1 {
  // border: 1px solid rgba(226, 223, 223, 1);
  padding: 1%;
  margin: 1.5% 0;
  text-align: left;
}
.credit_back {
  border: 1px solid rgba(226, 223, 223, 1);
  padding: 10px 15px;
  background: url("/static/icon/active.png") right no-repeat;
  background-position-y: 30px;
}
.row_sty {
  display: inline-block;
}
.main-right {
  background: #fff;
  min-height: 760px;
  width: 80%;
}

.y-header-item-z {
  margin-left: 10%;
  margin-top: 10px;
}
.y-header-item-z1 {
  padding-top: 4%;
  margin-left: 20px;
}
.y-header-item-z1-xiu {
  color: #c39a58;
}
.y-header-item-z2 {
  // margin-top: 8%;
  // padding-top: 7%;
  // position: relative;
  // padding-left: 20%;
}
.y-header-item-z2:before {
  // content: "";
  // position: absolute;
  // width: 100%;
  // height: 100%;
  // right: inherit;
  // top: 45%;
  // left: 15px;
  // bottom: 0;
  // background: url("/static/image/xo-yu.png") no-repeat;
}
.y-header-item-z2-p {
  color: #ff0000;
  font-size: 20px;
}
.y-right-main {
  // padding-left: 3%;
}
.y-right-main-top h3 {
  color: #c39a58;
}
.y-right-main-center {
  padding-left: 4px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.y-right-main-bottom p {
  color: #e3101e;
  text-align: center;
}
.y-right-main-center-list {
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 2%;
  width: 100%;
}
.y-right-main-center-list-item {
  width: 20%;
  padding: 0 1%;
  margin-top: 1%;
  border: 1px solid #efefef;
  float: left;
}
.u-list {
  background: #fff;
  text-align: left;
}

.z-color {
  color: #c40000;
  font-weight: bold;
}
.u-list .el-button.is-round {
  // padding: 5px 15px;
  margin-left: 4%;
  /*margin-top: 3%;*/
  /*width: 80%;*/
}
.u-list-img {
  text-align: center;
}
.u-list-img-img {
  margin: 3% 0;
  width: 90%;
}
.btn_class{
  padding: 7px 15px;
}
/deep/.el-dialog__body{
  padding: 1% 2% 5% 1%;
}
.col-10 {
  margin-left: 1%;
  width: 82%;
}
.col-10-1 {
  background-image: url("/static/image/roundedRectangle.png");
  background-size: contain;
  background-repeat: no-repeat;
  margin-bottom: 0;
}
.account .content-row {
  margin: 5% 0 0 10%;
  text-align: left;
  font-size: 14px;
  font-weight: bold;
}
.col-2-left,
.account,
.credit {
  text-align: center;
  height: 6rem;
}

.credit .recommend-img,
.credit span {
  float: left;
}
.credit span {
  width: 50%;
  display: inline-block;
}
.order-div {
  border: 1px solid lightgray;
  width: 98%;
  text-align: center;
  margin-bottom: 2%;
  float: left;
}
.my-order-div {
  border: 1px solid #eee;
  margin-bottom: 1%;
  margin-left: 3px;
  display: flex;
  margin-top: 15px;
  width: 99%;
}
.order-div-row-1 {
  // border-bottom: 1px solid lightgray;
  line-height: 1rem;
  // border-bottom: 1px dashed lightgray;
}
.order-div-row-2 span {
  // line-height: 4rem;
}

.span-price {
  color: red;
  font-weight: bold;
  cursor: pointer;
}
.search-all-orders {
  text-align: center;
  margin-bottom: 1%;
  font-size: 14px;
}
.collection-div {
  width: 17%;
  float: left;
  border: 1px solid lightgray;
  margin: 0 0.5% 0 0;
  padding: 1%;
  margin-bottom: 1%;
}
.credit-img {
  width: 4rem;
  height: 4rem;
  border-radius: 6rem;
  float: left;
}
.col-3-1 {
  text-align: center;
}
.col-3-1 span {
  float: left;
}
.col-3-action {
  text-align: center;
  margin: -0.5% 0 1% 0;
}
.order-code {
  text-align: center;
}
.good-img {
  width: 4rem;
  height: 4rem;
  float: left;
  margin-left: 1%;
  margin-right: 3%;
}
.edit-password {
  color: #409eff;
  margin-left: 5%;
  line-height: 5px;
}
.active,
.active i {
  background-color: lightsteelblue !important;
  display: block;
  color: royalblue !important;
}
.top-title {
  margin: 1%;
}
.title {
  text-align: left;
  font-size: 14px;
  color: #4e85ce;
  margin: 2%;
}
.span-balance {
  font-size: 14px;
  color: darkgray;
  line-height: 2rem;
}
.order {
  margin-bottom: 0;
}
.customized-button {
  padding: 2%;
}
.third-row,
.four-row,
.five-row {
  text-align: left;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden; /* 内容超出宽度时隐藏超出部分的内容 */
  text-overflow: ellipsis;
}
.third-row,
.four-row,
.five-row span {
  float: left;
  cursor: pointer;
}
.six-row {
  color: darkgray;
}
.seven-row {
  text-align: center;
}
.hiddenInput {
  display: none;
}
.photo {
  width: 100%;
  height: 100%;
  border-radius: 2rem;
  line-height: 10.5rem;
}
.recommend-img {
  width: 5rem;
  height: 5rem;
  border-radius: 6rem;
  cursor: pointer;
}
.recommend-menu {
  float: left;
  padding: 0;
  margin: 0;
  width: 80%;
  text-align: center;
}
.recommend-menu i {
  float: left;
  margin-right: -15%;
  margin-left: 15%;
  line-height: 1.5;
}
.recommend-menu li {
  float: left;
  list-style-type: none;
  width: 100%;
  border: 1px solid lightgray;
  font-size: 14px;
  padding: 1rem;
  cursor: pointer;
  font-weight: 600;
}
.fa-shopping-cart {
  margin-right: 10%;
  margin-left: -5%;
}
.hide {
  display: none;
}
.has-gutter {
  display: none;
}
.el-table__header-wrapper {
  display: none;
}
.order-list {
  width: 100%;
  padding: 0;
}
.order-list li {
  float: left;
  width: 12%;
  background-color: #6696c9;
  list-style-type: none;
  color: #fff;
  height: 2.5rem;
  line-height: 2.5rem;
  text-align: center;
  border-right: 2px solid #fff;
  cursor: pointer;
}
.order-list-active {
  background-color: #fff !important;
  color: #409eff !important;
  border: 1px solid #409eff;
  box-sizing: border-box;
  // box-shadow: 0px 0px 7px blue inset;
}
.search-div {
  text-align: left;
  margin-left: 3%;
}
.search-div .el-input {
  width: 40%;
}
.table-title {
  background-color: whitesmoke;
  padding: 1rem 0 1rem 0;
}
.el-pagination {
  float: right;
}
.el-table td {
  text-align: center;
}
.my-collection-row {
  text-align: left;
}
.saved-address {
  background-color: #f9f5ee;
  padding: 1rem 0 1rem 1%;
  font-size: 13px;
}
.gray-font-row {
  color: darkgray;
}
.left-1rem {
  margin-left: 1rem;
}
.fa-exclamation-circle {
  color: #ef8c57;
}
.el-dialog {
  display: table;
}
.add-address {
  width: 20%;
  height: 5rem;
  border: 2px dashed lightgray;
  border-radius: 10px;
  margin: 4% auto;
  line-height: 5rem;
  cursor: pointer;
}
.data-row {
  margin-top: 2%;
}
.center-td {
  text-align: center;
}

.col-12-dialog {
  text-align: left;
}
.col-12-dialog .el-select {
  margin-left: 1%;
}
.col-6-dialog span,
.col-6-dialog .el-input,
.col-12-dialog span,
.col-12-dialog .el-input,
.col-12-dialog .el-textarea {
  float: left;
  line-height: 2rem;
}
.col-12-dialog .col-10 {
  margin: 0;
}
.col-6-dialog .col-3 span {
  float: right;
  /*margin-right: 10%;*/
  margin-right: 10px;
  line-height: 2rem;
}
.col-6-dialog .col-3 .redstar {
  float: left;
  display: contents;
}
.el-icon-chat-dot-round {
  color: red;
  cursor: pointer;
}
.action-row {
  width: 30%;
  float: right;
  margin: -6.5% 4% 0 0;
}
.address-row {
  margin-left: 4%;
}
.default-address-row {
  margin: 1% 0 3% 12%;
}
.default_address {
  display: inline-block;
  color: #337fdf;
  line-height: 2rem;
  text-align: center;
}
.no-default-address {
  height: 2rem;
  display: inline-block;
  line-height: 2rem;
  text-align: center;
  cursor: pointer;
}
.edit-span,
.del-span {
  cursor: pointer;
}
.detail-div {
  background-image: url(/static/image/red_box.png);
  // border: 1px solid red;
  width: 22%;
  height: 6rem;
  display: inline-block;
  background-repeat: round;
  padding: 1%;
  margin-top: 1%;
}
.application-row {
  margin: 1% 0 2% 0;
}
.approval-row {
  margin: 1% 0 1% 0;
  padding: 1.5%;
  background-color: whitesmoke;
}
.note-div {
  border: 1px solid lightgray;
  padding: 0%;
}
.psinfo {
  margin: 2%;
}
.psinfo span {
  margin: 2%;
}
.psinfo .el-textarea {
  width: 95%;
}
.el-divider--horizontal {
  margin-top: 5%;
}
.personal-row {
  margin-bottom: 0;
  margin-top: 1%;
}
.orderalign .el-dialog .el-dialog__header {
  display: none;
}
.orderalign .el-dialog .el-dialog__body {
  display: contents;
}
.el-dialog__body {
  display: contents;
}
.span-request {
  display: block;
  margin-right: 2%;
  float: left;
}
.new-return-request .col-11 .span-request {
  margin-right: 1%;
}
.new-return-request {
  border: 1px solid lightgray;
  padding: 3% 0 3% 2%;
  line-height: 2.5;
  margin-top: 2%;
  width: 98%;
}
.new-return-request .el-input {
  width: 57%;
}
.new-return-request .el-textarea {
  width: 86%;
}
.new-return-request .el-select {
  width: 57%;
}
.new-return-request .el-table {
  width: 86%;
}
.button-row {
  margin: 2% 0 0 9.5%;
}
.filter-row {
  margin: 1% 0 1% 0;
}
.span-title {
  font-weight: 600;
  font-size: 15px;
}
.span_title {
  color: #c39a58;
}
.record-pay {
  background-color: #fc6f6f;
  text-align: center;
  width: 50%;
  height: 6rem;
  margin: 5% 0 2% 30%;
  color: #fff;
  border-radius: 10px;
}
.record-debit {
  background-color: #1fd0ad;
  text-align: center;
  width: 50%;
  height: 6rem;
  margin: 5% 0 2% 10%;
  color: #fff;
  border-radius: 10px;
}
.left {
  text-align: left;
}
.right {
  text-align: right;
}
.center {
  text-align: center;
}
.current-status {
  width: 50%;
}
.el-dialog__body {
  padding: 10px 10px 20px 10px;
}

/* 订单 */
.a-order {
  display: flex;
}
.a-order-left {
  width: 20%;
  line-height: 40px;
  text-align: center;
}
.a-my-order-list {
  // flex: 1;
}
.a-my-order-list1 {
  text-align: left;
}
.b-my-order {
  padding: 0 15px;
}
.a-my-order-list2 {
  padding-right: 15px;
}
.main-left {
}

.c_span {
  color: red;
}
// 个人中心
.c-list {
  padding-left: 15px;
}
.el-submenu__title {
  font-size: 16px;
}
// 流水记录
.f-17 {
  font-size: 1.25rem;
  text-align: left;
  padding-left: 15px;
}
// 注册信息
.d-region {
  text-align: left;
  min-height: 300px;
  margin-top: 15px;
  padding: 15px;
  color: #636363;
  font-size: 14px;
}
.d-button-edit {
  background-color: #c39a58;
  padding: 5px 40px;
  color: #fff;
  border: none;
}
.d-input-password {
  background-color: #fff;
  border: none;
}

.b-invoice {
  text-align: left;
}
.b-font-fp {
  font-size: 14px;
}
.y-header-item-z {
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .avatar {
    width: 108px;
    height: 108px;
    display: block;
    border-radius: 50%;
  }

  .imgblock {
    width: 50px;
    height: 50px;
    margin-right: 20px;
    line-height: 1;
    float: left;
    border: 1px solid #ccc;
    display: inline-table;
    overflow: hidden;
    border-radius: 5px;
    img {
      display: block;
      width: 100%;
    }
  }
}
.left-img .y-img-ring {
  width: 75px;
  height: 75px;
  display: block;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 20px;
}
.el-menu-vertical-demo{
  padding-bottom: 5%;
}
/deep/ .el-menu-item,
.el-submenu__title {
  height: 35px;
  line-height: 35px;
}
/deep/.el-menu-item-group__title {
  padding: 0px;
}
/deep/.el-button--mini,
.el-button--mini.is-round {
  padding: 6px 15px;
}
.content-table{
  background-color:whitesmoke;
  /*width:65%*/
}
/*@media screen and (min-width : 1440px){*/
/*  .content-table {*/
/*    margin-left: 7%;*/
/*    min-height: 500px;*/
/*    width: 82%;*/
/*    overflow-y: auto;*/
/*    overflow-y: auto;*/
/*  }*/
  .order-goods{
    width: 100%;
  }
/*  /deep/.el-table__body{*/
/*    min-width: 1000px;*/
/*    width: 100%;*/
/*  }*/
/*  /deep/.el-table__row{*/
/*    !*min-width: 1080px;*!*/
/*    width: 100%;*/
/*  }*/
/*  .main-left{*/
/*    min-width: 175px !important;*/
/*  }*/
/*}*/
/*@media screen and (min-width : 1366px) and (max-width:1440px) {*/
/*  .content-table {*/
/*    margin-left: 7%;*/
/*    min-height: 500px;*/
/*    width: 84.5%;*/
/*    overflow-y: auto;*/
/*    overflow-y: auto;*/
/*  }*/
/*  .main-left{*/
/*    min-width: 175px !important;*/
/*  }*/
/*}*/
/*@media screen and (min-width : 1280px) and (max-width:1366px) {*/
/*  .content-table {*/
/*    margin-left: 4%;*/
/*    min-height: 500px;*/
/*    width: 87.5%;*/
/*    // margin-top: 10%;*/
/*    overflow-y: auto;*/
/*    overflow-y: auto;*/
/*  }*/
/*}*/
.personal-header {
  display: flex;
  font-size: 14px;
  background-image:url(../../../static/image/header1.png);
  height: 150px;
  background-position: center;
  // background-size: 100% 100%;
}
.personal-header-left {
  display: flex;
  width: 50%;
}
.personal-order {
  background: #fff;
}
.personal-oder-page {
  height: 30px;
  margin: 10px;
}

.y-right-header-item {
  flex: 1;
  margin-left: 5%;
}
.a-my-order {
  display: flex;
  justify-content: space-between;
  line-height: 28px;
  padding: 0.5rem;
  background: #eeeeee;
}
/deep/.order-goods .el-table__header-wrapper {
  height: 0px;
}
/deep/td[rowspan="2"] {
  border-left: 1px solid #f5f5f5;
}
/deep/.join-cart {
  padding: 3% 5% !important;
  min-width: 85px;
  color: #999999 !important;
  background: none !important;
  border-color: #ddd !important;
  /*padding: 7px 30px ;*/
}
/deep/.join-cart-sc{
  padding: 3% 5% !important;
  min-width: 85px;
}
/deep/.join-cart:hover {
  color: #fff !important;
  background: #c40000 !important;
  border-color: #c40000 !important;
  padding: 3% 5% !important;
}
/deep/.search {
  width: 100%;
}
/deep/.search .el-input__inner {
  border-radius: 50px;
  height: 34px;
}
.a-order-right {
  margin: 10px;
  width: 35%;
}
/deep/ .el-submenu__title {
  text-align: left;
}
/deep/.el-submenu__icon-arrow {
  position: absolute;
  top: 55%;
  right: 46px;
}
.col-12 {
  margin-top: 15px;
}
.goods-btn{
  display: flex;
  width: 90%;
  margin-top: 2%;
  justify-content: center;
  /*position: absolute;*/
  /*bottom: 2%;*/
}
</style>
<style lang="css">
.el-table__header tr,
.el-table__header th {
  padding: 0;
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Personal/index.vue